import { CarouselMediaCardProps } from '@app/components/CarouselSection/types';
import {
  SimilarDesignItem,
  SimilarDesigns,
} from '@app/data/clients/rbServerSideClient/queries/GetSimilarDesigns/types';

function getPathFromUrl(url: string | undefined | null): string | undefined {
  if (!url) return undefined;
  try {
    // Try to create a URL object
    return new URL(url).pathname;
  } catch {
    // If it fails, assume it's already a path
    return url;
  }
}
export const mapMediaCardProps = (
  handleNavigate: (
    event: MouseEvent,
    link: string,
    inventoryItem: SimilarDesignItem['inventoryItem'],
    index: number
  ) => void
) => {
  return (
    inputData: SimilarDesignItem,
    _,
    index
  ): CarouselMediaCardProps | null => {
    const inventoryItem = inputData?.inventoryItem;
    const inventoryItemId = inventoryItem?.id;

    if (!inventoryItem || !inventoryItem.productPageUrl) return null;

    const link = getPathFromUrl(inventoryItem.productPageUrl);

    return {
      productId: inventoryItemId,
      link,
      imageSrc: inventoryItem.work.portfolioPreview?.url,
      workTitle: inventoryItem.work.title || '',
      loading: false,
      key: `offsite-sd-${inventoryItemId}`,
      testId: `offsite-sd-media-card-${inventoryItemId}`,
      matureContent: inventoryItem.work.matureContent,
      artistName: inventoryItem.work.artistUsername || '',
      onClick: (event: MouseEvent) =>
        handleNavigate(event, link || '', inventoryItem, index),
      stockStatus: inventoryItem.stockStatus,
    };
  };
};

// consolidate with the same function in similardesignssection
export const getUsableSimilarDesigns = (similarDesigns: SimilarDesigns) => {
  return similarDesigns
    .map((recommendation: SimilarDesignItem) => {
      if (recommendation.inventoryItem?.productPageUrl) return recommendation;
      return null;
    })
    .filter(Boolean);
};
